import axiosInstance from '@/config/http.config'

export function getKeyOperation() {
    return axiosInstance.get('/mtc/initday')
}

export function consultarVehiculo(data) {
    return axiosInstance.post('/mtc/consultar-vehiculo', data)
}

export function getAllSecondMtc(placa) {
    return axiosInstance.get(`/mtc/counter-vehicle/${placa}`);
}

export function cierreOperaciones(data) {
    return axiosInstance.post('/mtc/cierre-operaciones', data)
}